module.exports = __webpack_public_path__ + "static/media/FAU_icon.a0d1d3a1.png";